"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicBanner = void 0;
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const utils_1 = require("./utils");
class DynamicBannerError extends Error {
    constructor(message) {
        super(message);
        this.name = 'DynamicBannerError';
    }
}
function useDynamicBanner(params) {
    const contentForHome = (0, hooks_1.useDynamicContentForHome)({ resellerSlug: params.resellerSlug });
    const bannerContent = (0, react_1.useMemo)(() => {
        var _a, _b;
        try {
            return (0, utils_1.extractBannerFromDynamicContentForHome)(params.componentName, (_a = contentForHome.data) !== null && _a !== void 0 ? _a : null);
        }
        catch (error) {
            (_b = window.NREUM) === null || _b === void 0 ? void 0 : _b.noticeError(new DynamicBannerError('Banner config schema validation failed'), {
                customAttributes: {
                    component: params.componentName,
                    error: error instanceof Error ? error.message : String(error),
                },
                customError: true,
            });
            return null;
        }
    }, [contentForHome.data, params.componentName]);
    return Object.assign(Object.assign({}, contentForHome), { data: bannerContent });
}
exports.useDynamicBanner = useDynamicBanner;
